<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card class="list-view-item mb-8" v-on="$listeners">
    <template slot="no-body">
      <form data-vv-scope="add-new-product-to-cart">
        <div class="vx-row item-details no-gutter">
          <!-- IMG COL -->
          <div
            class="vx-col sm:w-1/4 w-full item-img-container flex items-center justify-center"
          >
            <img :src="item.photo" :alt="item.name" class="grid-view-img p-4" />
          </div>

          <!-- ITEM NAME & DESC COL -->
          <div class="vx-col sm:w-1/2 w-full">
            <div class="p-4 pt-6">
              <slot name="item-meta">
                <h6 class="item-name font-semibold mb-1 hover:text-dark">
                  {{ item.title }}
                </h6>
              </slot>
            </div>
            <p v-if="item.inStock" class="text-success text-sm pl-4">
              Lieferbar
            </p>
            <vs-collapse
              type="margin"
              v-if="
                item.sauces.length > 0 ||
                item.meats.length > 0 ||
                item.salads.length > 0 ||
                item.extras.length > 0 ||
                item.pomm_rice.length > 0 ||
                item.drinks.length > 0 > 0
              "
            >
              <vs-collapse-item
                :class="
                  openIngredientsCollapsable ? 'border-2 border-danger' : null
                "
                icon-pack="feather"
                icon-arrow="icon-chevrons-down"
              >
                <div
                  slot="header"
                  :class="
                    openIngredientsCollapsable ? 'text-danger' : 'text-dark'
                  "
                >
                  Beilagen wählen
                </div>

                <div class="options">
                  <p
                    v-if="item.sauces.length > 0"
                    class="font-medium text-grey"
                  >
                    <label class="text-sm">Sauce:</label>
                    <v-select
                      name="selectedSauces"
                      v-validate="'required'"
                      v-model="selectedSauces"
                      multiple
                      :options="
                        item.sauces.map((sauce) => {
                          return sauce.price > 0
                            ? {
                                label:
                                  sauce.name +
                                  ' (+ ' +
                                  String(sauce.price) +
                                  '€)',
                                price: sauce.price,
                                _id: sauce._id,
                              }
                            : {
                                label: sauce.name,
                                price: sauce.price,
                                _id: sauce._id,
                              };
                        })
                      "
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    />
                    <span
                      v-show="
                        errors.has('add-new-product-to-cart.selectedSauces')
                      "
                      class="text-danger"
                      >Gib mindestens eine Sauce an</span
                    >
                  </p>

                  <p v-if="item.meats.length > 0" class="font-medium text-grey">
                    <label class="text-sm">Fleisch:</label>
                    <v-select
                      name="selectedMeats"
                      v-validate="'required'"
                      v-model="selectedMeats"
                      multiple
                      :options="
                        item.meats.map((meat) => {
                          return meat.price > 0
                            ? {
                                label:
                                  meat.name +
                                  ' (+ ' +
                                  String(meat.price) +
                                  '€)',
                                price: meat.price,
                                _id: meat._id,
                              }
                            : {
                                label: meat.name,
                                price: meat.price,
                                _id: meat._id,
                              };
                        })
                      "
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    />
                    <span
                      v-show="
                        errors.has('add-new-product-to-cart.selectedMeats')
                      "
                      class="text-danger"
                      >Gib mindestens ein Fleisch an</span
                    >
                  </p>

                  <p
                    v-if="item.salads.length > 0"
                    class="font-medium text-grey"
                  >
                    <label class="text-sm">Salat:</label>
                    <v-select
                      name="selectedSalads"
                      v-validate="'required'"
                      v-model="selectedSalads"
                      multiple
                      :options="
                        item.salads.map((salad) => {
                          return salad.price > 0
                            ? {
                                label:
                                  salad.name +
                                  ' (+ ' +
                                  String(salad.price) +
                                  '€)',
                                price: salad.price,
                                _id: salad._id,
                              }
                            : {
                                label: salad.name,
                                price: salad.price,
                                _id: salad._id,
                              };
                        })
                      "
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    />
                    <span
                      v-show="
                        errors.has('add-new-product-to-cart.selectedSalads')
                      "
                      class="text-danger"
                      >Gib mindestens einen Salat an</span
                    >
                  </p>

                  <p
                    v-if="item.extras.length > 0"
                    class="font-medium text-grey"
                  >
                    <label class="text-sm">Extra:</label>
                    <v-select
                      v-model="selectedExtras"
                      multiple
                      :options="
                        item.extras.map((extra) => {
                          return extra.price > 0
                            ? {
                                label:
                                  extra.name +
                                  ' (+ ' +
                                  String(extra.price) +
                                  '€)',
                                price: extra.price,
                                _id: extra._id,
                              }
                            : {
                                label: extra.name,
                                price: extra.price,
                                _id: extra._id,
                              };
                        })
                      "
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    />
                  </p>

                  <p
                    v-if="item.pomm_rice.length > 0"
                    class="font-medium text-grey"
                  >
                    <label class="text-sm">Pommes & Reis:</label>
                    <v-select
                      v-model="selectedPommRice"
                      name="selectedPommRice"
                      v-validate="'required'"
                      :options="
                        item.pomm_rice.map((pr) => {
                          return pr.price > 0
                            ? {
                                label:
                                  pr.name + ' (+ ' + String(pr.price) + '€)',
                                price: pr.price,
                                _id: pr._id,
                              }
                            : { label: pr.name, price: pr.price, _id: pr._id };
                        })
                      "
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    />
                    <span
                      v-show="
                        errors.has('add-new-product-to-cart.selectedPommRice')
                      "
                      class="text-danger"
                      >Gib eine Beilage an</span
                    >
                  </p>

                  <p
                    v-if="item.drinks.length > 0"
                    class="font-medium text-grey"
                  >
                    <label class="text-sm">Getränke:</label>
                    <v-select
                      v-model="selectedDrink"
                      name="selectedDrink"
                      v-validate="'required'"
                      :options="
                        item.drinks.map((drink) => {
                          return {
                            label: drink.name,
                            price: drink.price,
                            _id: drink._id,
                          };
                        })
                      "
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    />
                    <span
                      v-show="
                        errors.has('add-new-product-to-cart.selectedDrink')
                      "
                      class="text-danger"
                      >Gib ein Getränk an</span
                    >
                  </p>

                  <div v-if="item.drinks.length > 0" style="height: 100px">
                    &nbsp;
                  </div>
                  <div style="height: 100px">&nbsp;</div>
                  <div class="mt-8 italic text-sm">{{ item.description }}</div>
                </div>
              </vs-collapse-item>
            </vs-collapse>
          </div>

          <!-- PURCHASE COL -->
          <div class="vx-col sm:w-1/4 w-full flex items-center">
            <div class="p-4 flex flex-col w-full">
              <div class="my-6">
                <h5 class="font-bold text-center">
                  {{ item.price.toFixed(2) }}€
                </h5>
              </div>

              <!-- SLOT: ACTION BUTTONS -->
              <!-- SLOT: ACTION BUTTONS -->

              <!-- SECONDARY BUTTON: MOVE-TO/VIEW-IN WISHLIST -->
              <div
                class="item-view-secondary-action-btn bg-dark p-3 rounded-lg flex flex-grow items-center justify-center text-white cursor-pointer"
                @click.prevent="onAddToCart(item, index)"
              >
                <span class="text-sm font-semibold ml-2">HINZUFÜGEN</span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
  </vx-card>
</template>

<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      // TAB 1
      selectedSauces: [],
      selectedMeats: [],
      selectedSalads: [],
      selectedExtras: [],
      selectedPommRice: null,
      selectedDrink: null,
      openIngredientsCollapsable: false,
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    cartItems: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isInCart() {
      return (itemId) => this.$store.getters["eCommerce/isInCart"](itemId);
    },
    isInWishList() {
      return (itemId) => this.$store.getters["eCommerce/isInWishList"](itemId);
    },
  },
  methods: {
    onAddToCart(item) {
      return new Promise(() => {
        this.$validator
          .validateAll("add-new-product-to-cart")
          .then((result) => {
            if (result) {
              // if form have no errors

              //check if the exact item is already in cart
              let res = this.cartItems.find(
                (cartItem) => cartItem._id === item._id
              );
              if (res) {
                if (
                  JSON.stringify(this.selectedSauces) !==
                    JSON.stringify(res.selectedSauces) ||
                  JSON.stringify(this.selectedMeats) !==
                    JSON.stringify(res.selectedMeats) ||
                  JSON.stringify(this.selectedSalads) !==
                    JSON.stringify(res.selectedSalads) ||
                  JSON.stringify(this.selectedExtras) !==
                    JSON.stringify(res.selectedExtras) ||
                  JSON.stringify(this.selectedPommRice) !==
                    JSON.stringify(res.selectedPommRice) ||
                  JSON.stringify(this.selectedDrink) !==
                    JSON.stringify(res.selectedDrink)
                ) {
                  // product is already in cart but with other ingredients -> add new item in cart

                  const payload = {
                    ...item,
                    selectedSauces: this.selectedSauces,
                    selectedMeats: this.selectedMeats,
                    selectedSalads: this.selectedSalads,
                    selectedExtras: this.selectedExtras,
                    selectedPommRice: this.selectedPommRice,
                    selectedDrink: this.selectedDrink,
                  };
                  this.$store.dispatch("shop/additemInCart", payload);
                } else {
                  //product is already in cart with exactly same ingredients
                  this.$store.commit("shop/UPDATE_ITEM_QUANTITY", {
                    cartItemID: res.cartItemID,
                    newValue: res.quantity + 1,
                  });
                }
              } else {
                //product is not yet in cart -> add it to cart
                const payload = {
                  ...item,
                  selectedSauces: this.selectedSauces,
                  selectedMeats: this.selectedMeats,
                  selectedSalads: this.selectedSalads,
                  selectedExtras: this.selectedExtras,
                  selectedPommRice: this.selectedPommRice,
                  selectedDrink: this.selectedDrink,
                };
                this.$store.dispatch("shop/additemInCart", payload);
              }

              // show cart on mobile devices
              this.$emit("onShowCartButtonOnMobile");
            } else {
              (this.openIngredientsCollapsable = true),
                this.$vs.notify({
                  title: "Fehler",
                  text: "Du musst zunächst deine Beilagen wählen",
                  color: "danger",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                });
            }
          });
      });
      // check if all necessary ingredients have been added
      /*      const productIndex = this.products.findIndex(product => product.id === item.id);
      const relatedProduct = this.products[productIndex];
      if ((relatedProduct.sauces && this.selectedSauces[index])) */
      /*  if (this.selectedSauces[index] && this.selectedMeats[index] && this.selectedSalads[index] && this.selectedExtras[index]) {
      const payload = {...item, selectedSauces: this.selectedSauces[index], selectedMeats: this.selectedMeats[index], selectedSalads: this.selectedSalads[index], selectedExtras: this.selectedExtras[index] }
      this.$store.dispatch('shop/additemInCart', payload)
      } else {
         this.$vs.notify({
              title: 'Fehler',
              text: 'Wähle zuerst deine Beläge!',
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })  
      } */
    },
  },
  components: {
    vSelect,
  },
};
</script>

<style lang="scss" scoped>
.list-view-item {
  .item-name,
  .item-description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .item-name {
    -webkit-line-clamp: 2;
  }

  .item-description {
    -webkit-line-clamp: 5;
  }

  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: 0.35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
</style>
